import usePostDraft, { DraftFormValue, DraftType } from '@/utils/hooks/usePostDraft'
import { useWatch } from 'react-hook-form'
import { useDebounce } from 'react-use'
import type { PostFormValue } from './PostForm/types'

export default function AutoSaveService({ draftType }: { draftType: DraftType }) {
	const formValues = useWatch<DraftFormValue<typeof draftType>>()
	const [, setDraft] = usePostDraft(draftType)
	const [isReady, cancel] = useDebounce(
		() => {
			setDraft(formValues as PostFormValue)
		},
		300,
		[formValues]
	)

	return null
}
